import Vue from 'vue';
import Message from './message';

const instances = [];
let seed = 0;
let container;
let config = {};

const message = function(options) {
  if (!container) {
    container = document.createElement('div');
    container.style.position = 'fixed';
    container.style.top = `${options.offset || 14}px`;
    container.style.height = 0;
    container.style.zIndex = 99999;
    document.body.appendChild(container);
  }

  seed += 1;
  const id = `message__${seed}`;
  const instance = { id, node: {}, wrapper: {} };

  const MComponent = Vue.extend({
    render(h) {
      return h(
        Message,
        {
          props: {
            ...config,
            ...options,
            onClose() {
              message.onClose(id, options.onClose);
            },
            onAfterClose() {
              instance.wrapper.$destroy();
              if (!instances.length && container) {
                document.body.removeChild(container);
                container = null;
              }
            },
          },
        }
      );
    },
  });
  instance.wrapper = new MComponent().$mount();
  instance.node = instance.wrapper.$children[0]; // eslint-disable-line
  instances.push(instance);
  container.appendChild(instance.node.$el);

  return instance.node;
};

const methods = ['success', 'warning', 'info', 'error'];

methods.forEach((type) => {
  message[type] = function(options) {
    let opts = options;
    if (typeof options === 'string') {
      opts = { content: options };
    }
    return message({ ...opts, type });
  };
});

message.close = function(id) {
  const instance = instances.find(item => item.id === id);
  if (instance) {
    instance.node.close();
    container.removeChild(instance.node.$el);
  }
};

message.onClose = function(id, userOnClose) {
  for (let i = 0, len = instances.length; i < len; i++) {
    if (id === instances[i].id) {
      if (typeof userOnClose === 'function') {
        userOnClose(instances[i]);
      }
      instances.splice(i, 1);
      break;
    }
  }
};

message.closeAll = function() {
  for (let i = instances.length - 1; i >= 0; i--) {
    message.close(instances[i].id);
  }
};

message.config = function(options) {
  config = options;
};

export default message;
